import React, { useState } from "react";
import "./RCQuickQuiz.css";

/**
 * RCQuickQuiz:
 *  - 6 questions about Roman Catholic teaching
 *  - One question at a time
 *  - Tracks score & shows final result
 */
export default function RCQuickQuiz() {
  const questions = [
    {
      question: "How does the Catholic Church help us to gain heaven?",
      correctAnswer:
        "The Catholic Church helps us to gain heaven especially through the sacraments.",
      options: [
        "By ignoring sin in the world",
        "Through the power of human laws",
        "The Catholic Church helps us to gain heaven especially through the sacraments.",
        "By teaching only about history",
      ],
    },
    {
      question: "What is a Sacrament?",
      correctAnswer:
        "A Sacrament is an outward sign, instituted by Christ to give grace.",
      options: [
        "An invention of modern philosophers",
        "A community party where people gather",
        "A Sacrament is an outward sign, instituted by Christ to give grace.",
        "A ceremony found only in ancient times",
      ],
    },
    {
      question: "What is Baptism?",
      correctAnswer:
        "Baptism is a sacrament that gives our souls the new life of grace by which we become children of God.",
      options: [
        "A minor ceremony to pick a child’s name",
        "A cultural festival for newborns",
        "Baptism is a sacrament that gives our souls the new life of grace by which we become children of God.",
        "A school enrollment process",
      ],
    },
    {
      question: "Why do I receive the sacrament of Baptism first?",
      correctAnswer:
        "I receive the sacrament of Baptism first because it takes away original sin and makes me a child of God.",
      options: [
        "Because it makes me an adult in the church instantly",
        "I receive the sacrament of Baptism first because it takes away original sin and makes me a child of God.",
        "Because I need to learn many prayers first",
        "There is no specific reason for the order",
      ],
    },
    {
      question: "Who baptizes us?",
      correctAnswer: "The Priest baptizes us.",
      options: [
        "Our grandparents typically do it",
        "Any member of the parish can do it",
        "The Priest baptizes us.",
        "It must be done by the bishop only",
      ],
    },
    {
      question: "What is sin?",
      correctAnswer: "Sin is disobedience to God's laws.",
      options: [
        "Sin is any unfortunate accident",
        "Sin is disobedience to God's laws.",
        "Sin is just a personal opinion of wrong",
        "Sin is something only some people do",
      ],
    },
  ];

  // State to track current question index & score
  const [currentIndex, setCurrentIndex] = useState(0);
  const [selectedAnswer, setSelectedAnswer] = useState(null);
  const [feedback, setFeedback] = useState("");
  const [score, setScore] = useState(0);
  const [showResult, setShowResult] = useState(false);

  const currentQ = questions[currentIndex];

  const handleAnswer = (choice) => {
    setSelectedAnswer(choice);
    if (choice === currentQ.correctAnswer) {
      setFeedback("✅ Correct!");
      setScore((prev) => prev + 1);
    } else {
      setFeedback("❌ Incorrect. The correct answer is:\n" + currentQ.correctAnswer);
    }
  };

  const handleNext = () => {
    // If not the last question, move on
    if (currentIndex < questions.length - 1) {
      setCurrentIndex((prev) => prev + 1);
      setSelectedAnswer(null);
      setFeedback("");
    } else {
      // done => show result
      setShowResult(true);
    }
  };

  return (
    <div className="rcquickquiz-page">
      <h2 className="rcquickquiz-title">Roman Catholic Quick Quiz</h2>

      {!showResult && (
        <>
          <p className="rcquickquiz-description">
            Question {currentIndex + 1} of {questions.length}
          </p>
          <div className="rcquickquiz-question-block">
            <h3>{currentQ.question}</h3>
            <div className="rcquickquiz-options">
              {currentQ.options.map((opt, idx) => (
                <button
                  key={idx}
                  className={`rcquickquiz-btn ${
                    selectedAnswer === opt ? "selected" : ""
                  }`}
                  onClick={() => handleAnswer(opt)}
                  disabled={!!selectedAnswer} // disable if already chosen
                >
                  {opt}
                </button>
              ))}
            </div>
          </div>

          {feedback && (
            <p className="rcquickquiz-feedback" style={{ whiteSpace: "pre-wrap" }}>
              {feedback}
            </p>
          )}

          {/* Next button visible after user selects an answer */}
          {selectedAnswer && (
            <button onClick={handleNext} className="rcquickquiz-next-btn">
              {currentIndex < questions.length - 1 ? "Next" : "See Result"}
            </button>
          )}
        </>
      )}

      {showResult && (
        <div className="rcquickquiz-result-block">
          <h3>Your Final Score:</h3>
          <p>
            You got <strong>{score}</strong> out of{" "}
            <strong>{questions.length}</strong> correct!
          </p>
          <p className="rcquickquiz-congratulation">
            {score === questions.length
              ? "Excellent! You got them all correct."
              : "Good job! Keep learning and try again if you'd like."}
          </p>
        </div>
      )}
    </div>
  );
}
